import { useState, useEffect, useCallback } from 'react'

// Custom hook for managing Command K functionality
const useCommandK = () => {
  const [isOpen, setIsOpen] = useState(false)

  // Handle keyboard shortcut
  const handleKeyDown = useCallback((event) => {
    // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
    const isCommandK = isMac ? event.metaKey && event.key === 'k' : event.ctrlKey && event.key === 'k'
    
    if (isCommandK) {
      event.preventDefault()
      event.stopPropagation()
      setIsOpen(prev => !prev)
    }
    
    // Also handle Escape to close when open
    if (event.key === 'Escape' && isOpen) {
      setIsOpen(false)
    }
  }, [isOpen])

  // Set up global event listener
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  // Prevent body scroll when palette is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const openPalette = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closePalette = useCallback(() => {
    setIsOpen(false)
  }, [])

  const togglePalette = useCallback(() => {
    setIsOpen(prev => !prev)
  }, [])

  return {
    isOpen,
    openPalette,
    closePalette,
    togglePalette
  }
}

export default useCommandK